import React from 'react';
import { useNFOutrasOperacao } from '~/pages/NFOutrasOperacoes/NFOutrasOperacoesContext';
import { ItensFinaceiroProps } from '~/pages/NFOutrasOperacoes/protocols/ItensFinaceiroProps';
import CustomDataGrid from '../../../myComponents/CustomDataGrid';
import { ButtonRow, ContainerAcoes } from './styles';
import { FaTrash } from 'react-icons/fa';
import { GoPencil } from 'react-icons/go';
import { AgendamentoSelecionadosStorage } from '~/components/VincularAgendamento/class/AgendamentoSelecionadosStorage';
import { encontrarIdAgendamentoCorrespondente } from '~/components/VincularAgendamento/utils/encontrarIdAgendamentoCorrespondente';

const TableFinanceiro: React.FC = () => {
  const { parcelasFinanceiro, updateItemFinaceiro, deleteItemFinaceiro } =
    useNFOutrasOperacao();

  const columns = [
    {
      field: 'num_condicao',
      headerName: 'Prazo',
      width: 80,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'des_definicao',
      headerName: 'Condição',
      width: 200,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'des_finalizadora',
      headerName: 'Finalizadora',
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'dta_vencimento',
      headerName: 'Vencimento',
      width: 200,
      format: 'dta',
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'val_parcela',
      headerName: 'Valor da Parcela',
      width: 150,
      format: 'money',
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'flg_quitado',
      headerName: 'Quitado?',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (row: ItensFinaceiroProps) => {
        return (
          <ContainerAcoes>
            <input
              type="checkbox"
              id="flg_quitado"
              disabled
              checked={row.flg_quitado}
            />
          </ContainerAcoes>
        );
      },
    },
    {
      field: 'acoes',
      headerName: 'Ações',
      fixed: true,
      fixedDirection: 'right',
      width: 100,
      renderCell: (row: ItensFinaceiroProps) => {
        return (
          <>
            <ButtonRow
              type="button"
              disabled={row.isDisabled}
              isBlocked={row.isDisabled}
              onClick={() => updateItemFinaceiro(row, row.num_registro)}
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} />
            </ButtonRow>
            <ButtonRow
              type="button"
              disabled={row.isDisabled}
              isBlocked={row.isDisabled}
              onClick={() => {
                deleteItemFinaceiro(row.uuid);

                const id = encontrarIdAgendamentoCorrespondente(
                  AgendamentoSelecionadosStorage.get(172),
                  row,
                );

                AgendamentoSelecionadosStorage.removeById(String(id), 172);
              }}
            >
              <FaTrash size={20} style={{ color: '#e63c3c' }} />
            </ButtonRow>
          </>
        );
      },
    },
  ];

  return (
    <CustomDataGrid
      key="Financeiro"
      rows={parcelasFinanceiro}
      columns={columns}
      height="300px"
    />
  );
};

export default TableFinanceiro;
